import headerBg from '../assets/bg.png';
import logo from '../assets/logo.png';
import rhinos from '../assets/rhinos.png';
import roadmap from '../assets/roadmap.jpg';
import logoMap from '../assets/logo.svg';

const images = {
   logo,
   headerBg,
   rhinos,
   roadmap,
   logoMap
}

export default images;